export default __webpack_public_path__ + "ai-champion.63d4d2a6.png";